import { useEffect, useRef } from "react"

interface IProps {
 children: any
 callback: () => void
}

// component that detect the user clicked
export const OutSideClickHandler = ({ children, callback }: IProps) => {
 const ref = useRef<HTMLDivElement | null>(null)

 useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
   if (ref.current && !ref.current.contains(event.target as Node)) {
    callback()
   }
  }

  // EventListener that listening the mouse activity
  document.addEventListener("mousedown", handleClickOutside)

  return () => {
   document.removeEventListener("mousedown", handleClickOutside)
  }
 })
 return <div ref={ref}>{children}</div>
}
